import { z } from "zod";

export const aiPulseFrequencySchema = z.enum(["weekly", "biweekly", "monthly"]);
export type AiPulseFrequency = z.infer<typeof aiPulseFrequencySchema>;

export const aiPulseSettingsSchema = z
  .object({
    frequency: aiPulseFrequencySchema,
    questionCount: z.number().int(),
    lastRunAt: z.string().nullable(),
    nextRunAt: z.string().nullable(),
  })
  .strict();
export type AiPulseSettings = z.infer<typeof aiPulseSettingsSchema>;

/// Only the fields that changed are sent; the shore needs at least one.
export type UpdateAiPulseSettings = Partial<Pick<AiPulseSettings, "frequency" | "questionCount">>;
